import styled from 'styled-components';

const Container = styled.div`
  padding: 15px;
  display: flex;
  height: auto;
  position: relative;
  border-radius: 5px;
  box-shadow: ${({ selected }) => (selected ? '0px 10px 29px rgba(11, 26, 33, 0.1)' : 'none')};
  border: 1px solid transparent;

  ${({ selected }) => {
    if (!selected) {
      return `
        &:hover {
          cursor: pointer;
          background: var(--blue-1);
          border: 1px solid var(--blue-3);
        }
      `;
    }
  }}

  .in-page-features-v3--image {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    margin-top: ${({ multlineTitle }) => multlineTitle && '15px'};
  }

  img {
    width: 40px;
    height: 40px;
  }

  .in-page-features-v3--copy {
    width: 100%;

    .in-page-features-v3--title {
      color: var(--neutral-7);
      display: flex;
      align-items: center;
      font-weight: 700;
      width: fit-content;
      margin: 0;
      font-size: 17px;
      line-height: 25px;
      min-height: ${({ titleHeight }) => titleHeight};
    }

    .in-page-features-v3--sub-title {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    p {
      font-size: 14px;
      color: var(--neutral-text-color);
      font-weight: 500;
      min-height: 40px;
      margin-top: ${({ multiLineTitle }) => (multiLineTitle ? '8px' : 0)};
      margin-bottom: 0;
    }

    .in-page-features-v3--button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
`;

export { Container };
